var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"main-menu"},_vm._l((_vm.mainMenu),function(item,index){return _c('div',{key:index,staticClass:"main-menu__item",on:{"click":function($event){return _vm.scrollMeTo(item.id)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }